// extracted by mini-css-extract-plugin
module.exports = {"card-container":"_1wdsF","text-wrapper":"_2dBY1","res-img":"_3cdLI","headline":"_36yD3","subheadline":"_2eJUW"};